<div [hidden]="!PartialViewReady">
    <h2 class="mat-title">Alternative Assessments Test Cutoffs Editor</h2>
    <div>
        <div>
            Listed below are all defined college alternative assessments test score cutoffs. These are used to help provide guidance to
            school counselors and college advisors on which alternative means of proving competency for college course prerequisites
            are available in DELTA. For each test/score listed below, if you wish that entry to be color highlighted in DELTA for a
            specific minimum score, use the "Edit" button to edit the minimum necessary score and then use the "Activate" button to
            activate the entry in the system.
        </div>
    </div>

    <!-- Tests Table -->
    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px" class="margin-top">
        <mat-checkbox [(ngModel)]="OnlyActive" (change)="UpdateFilter()">Only show active scores</mat-checkbox>
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
            <div>Filter:</div>
            <mat-form-field floatPlaceholder="never" class="filter">
                <input matInput type="text" [(ngModel)]="FilterText" (input)="UpdateFilter()" placeholder="Enter filter..." />
            </mat-form-field>
        </div>
    </div>
    <mat-table class="bordered" #table [dataSource]="TestsData" matSort matSortActive="TestDescription" matSortDirection="asc">
        <ng-container matColumnDef="TestDescription">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Test</mat-header-cell>
            <mat-cell *matCellDef="let test" class="centered">{{ test.TestDescription }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="Description">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Score</mat-header-cell>
            <mat-cell *matCellDef="let test" class="centered">{{ test.Description }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="ScoreType">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Score Type</mat-header-cell>
            <mat-cell *matCellDef="let test" class="centered">{{ test.ScoreType }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="Score">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Score</mat-header-cell>
            <mat-cell *matCellDef="let test" class="centered">{{ test.Score }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="Active">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Active?</mat-header-cell>
            <mat-cell *matCellDef="let test" class="centered"
                ><span>{{ test.Active === true ? 'Yes' : 'No' }}</span></mat-cell
            >
        </ng-container>

        <ng-container matColumnDef="Actions">
            <mat-header-cell *matHeaderCellDef class="centered">Action(s)</mat-header-cell>
            <mat-cell *matCellDef="let test" class="centered">
                <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="15px" fxLayoutWrap>
                    <button mat-raised-button color="primary" (click)="EditTest(test)" class="buttonpad">Edit Score</button>
                    <button *ngIf="test.Active" mat-raised-button color="warn" (click)="DeactivateTest(test)" class="buttonpad">
                        Deactivate
                    </button>
                    <button
                        *ngIf="!test.Active && test.Score != null"
                        mat-raised-button
                        color="accent"
                        (click)="ActivateTest(test)"
                        class="buttonpad"
                    >
                        Activate
                    </button>
                    <button mat-raised-button color="warn" (click)="RemoveTest(test)" class="buttonpad">Remove Test</button>
                </div>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="SmallDisplay">
            <mat-header-cell *matHeaderCellDef class="centered">Term(s)</mat-header-cell>
            <mat-cell *matCellDef="let term">
                <!-- <div fxLayout="column" fxLayoutAlign="start stretch">
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <div>College Year</div>
                        <div>{{ term.CollegeSchoolYear | collegeSchoolYear: AdminCollege.CollegeID }}</div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <div>Term Code</div>
                        <div>{{ term.TermCode }}</div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <div>Term</div>
                        <div>{{ term.TermCode | collegeTerm }}</div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <div>Beginning Date</div>
                        <div>{{ term.DateBegin | datefns: 'M/DD/YYYY' }}</div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <div>Ending Date</div>
                        <div>{{ term.DateEnd | datefns: 'M/DD/YYYY' }}</div>
                    </div>
                    <div class="smalldisplaybuttongroup" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="10px">
                        <button mat-raised-button color="primary" (click)="ShowTermEntryEditorPanel(term)">Edit Term Window</button>
                        <button mat-raised-button color="warn" (click)="RemoveTerm(term)" [disabled]="term.InUse === true">
                            Remove Term Window
                        </button>
                    </div>
                </div> -->
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="NoData">
            <mat-header-cell *matHeaderCellDef>&nbsp;</mat-header-cell>
            <mat-cell *matCellDef="let term"><em>No test score thresholds have been set in the system.</em></mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="VisibleHeaders"></mat-header-row>
        <mat-row *matRowDef="let row; columns: VisibleColumns; let $even = even" [class.primarybackground50]="$even"></mat-row>
    </mat-table>
    <mat-paginator
        #paginator
        [length]="TestsData.data.length"
        [pageIndex]="0"
        [pageSize]="SmallDisplay ? 5 : 10"
        [pageSizeOptions]="[5, 10, 25, 100]"
    ></mat-paginator>
</div>



// WEBPACK FOOTER //
// ./src/app/managescores/managescores.component.html